// Get all elements with the class "accordion_title"
const accordionTitles = document.querySelectorAll('.accordion_title');

// Loop through each accordion title
accordionTitles.forEach(title => {
  // Add a click event listener to each title
  title.addEventListener('click', () => {
    // Toggle the "accordion_open" class on the clicked title
    title.classList.toggle('accordion_open');

    // Find the next sibling element with the class "accordion_content"
    const content = title.nextElementSibling;

    // Toggle the visibility of the content based on the "accordion_open" class
    if (title.classList.contains('accordion_open')) {
      content.style.display = 'block';
    } else {
      content.style.display = 'none';
    }
  });
});

// Get the sidebar and main container elements
const sidebar = document.querySelector('.technologies-sidebar');
const mainContainer = document.querySelector('.technologies-main-container');

// Get all the sidebar items
const sidebarItems = sidebar.querySelectorAll('.sidebar-item');

// Get all the technology wrappers
const technologyWrappers = mainContainer.querySelectorAll('.technology-wrapper');

// Add event listeners to the sidebar items
sidebarItems.forEach(item => {
  const anchor = item.querySelector('a');

  item.addEventListener('mouseover', () => {
    // Remove active classes from all sidebar items and technology wrappers
    removeActiveClasses();

    // Add "active" class to the current sidebar item and its anchor tag
    item.classList.add('active');
    anchor.classList.add('active');

    // Get the corresponding technology wrapper ID
    const anchorHref = anchor.getAttribute('href');
    const technologyWrapper = mainContainer.querySelector(anchorHref);

    // Add "active" class to the corresponding technology wrapper
    technologyWrapper.classList.add('active');
  });
});

// Helper function to remove active classes from all sidebar items and technology wrappers
function removeActiveClasses() {
  sidebarItems.forEach(item => {
    item.classList.remove('active');
    item.querySelector('a').classList.remove('active');
  });

  technologyWrappers.forEach(wrapper => {
    wrapper.classList.remove('active');
  });
}

